import React from 'react';
import { useField } from 'formik';
import { TFormikPropsWrapper, TGenericHTMLCompInterface } from './types';

const FormikPropsWrapper = <A extends TGenericHTMLCompInterface>({
    name,
    children,
    ...rest
}: React.PropsWithChildren<TFormikPropsWrapper>) => {
    const formikProps = useField<A>(name);

    return (
        (React.isValidElement(children) &&
            React.cloneElement(children, {
                ...children.props,
                ...formikProps[0],
                ...rest,
                meta: formikProps[1],
            })) ||
        null
    );
};

export default FormikPropsWrapper;
